import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-8af0d312"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bold-txt" }
const _hoisted_2 = { class: "uncheck-risk-cntr" }
const _hoisted_3 = {
  class: "tips",
  ref: "copyCntrTxt"
}
const _hoisted_4 = { class: "console-desc" }
const _hoisted_5 = { class: "unwarp-txt" }
const _hoisted_6 = { class: "bold-txt" }
const _hoisted_7 = { class: "console-desc" }
const _hoisted_8 = { class: "unwarp-txt" }
const _hoisted_9 = { class: "bold-txt" }
const _hoisted_10 = { class: "unwarp-txt" }
const _hoisted_11 = { class: "bold-txt" }
const _hoisted_12 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "append-to-body": "",
    modelValue: _ctx.modalVisiable,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modalVisiable) = $event)),
    "before-close": _ctx.closeModal,
    width: "470px"
  }, {
    title: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.innerContent?.title? _ctx.innerContent.title : _ctx.$t('safeProtectionModule.unnamedRiskItem')), 1)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_12, [
        _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyTxt()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.copyPlainText')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          _createElementVNode("li", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('safeProtectionModule.riskDescColon')), 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.innerContent.description), 1)
          ]),
          _createElementVNode("li", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('safeProtectionModule.engineColon')), 1),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.innerContent.engine), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payload, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "console-desc",
              key: item.k
            }, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(item.k) + "：", 1),
              _createElementVNode("pre", _hoisted_11, " " + _toDisplayString(item.v) + " ", 1)
            ]))
          }), 128))
        ], 512)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "before-close"]))
}